import ForkRight from '@mui/icons-material/ForkRight';
import { makeObservable, observable } from 'mobx';
import Dominios from '../../util/Dominios';
import { Filtro } from './Filtro';

export default class FiltroVotacaoComDivergencia extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Votação com pelo menos 1 divergência';
    }

    getIconeFiltroRapido() {
        return <ForkRight style={{ transform: 'rotate(90deg)' }} />;
    }

    filtroRapido = {
        valor: true
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        return (
            registro.votos &&
            registro.votos.findIndex((voto) => voto.voto?.codigo === Dominios.CODIGO_VOTO_DIVERGENTE) !== -1
        );
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
